module.exports = __webpack_public_path__ + "static/fig-03-b33f8e12a5cdfabb40c7193627432747.png";